export default __webpack_public_path__ + "static/media/Automatic LP.01341fa8.png";